export default __webpack_public_path__ + "static/media/person-f7.445bb4af.jpeg";